import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { Toaster } from "sonner";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(

  <Provider store={store}>
    <BrowserRouter>
      <Toaster richColors duration={3000} position="top-center" closeButton />

      <App />
    </BrowserRouter>
  </Provider>
);
reportWebVitals();
